export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-styleguide-b1f8f356bd682a04d6c04c3332307d7c.png";